<template>
  <div class="unllimg">
    <img :src="imgurl" alt="" />
    <p>暂无数据</p>
  </div>
</template>

<script>
export default {
  name: 'unllimg',
  data () {
    return {
      imgurl: '/static/unllimg.png'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./unllimg.scss";
</style>



// WEBPACK FOOTER //
// src/components/unllimg/unllimg.vue